<template>
  <transition name="toast">
    <div v-if="toast.show" class="toast">
      {{ toast.message }}
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Toast',
  computed: {
    ...mapState(['toast'])
  }
}
</script>

<style scoped>
.toast {
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--bg-glass-dark);
  backdrop-filter: blur(var(--blur-lg));
  -webkit-backdrop-filter: blur(var(--blur-lg));
  color: white;
  padding: 18px 28px;
  border-radius: 980px;
  font-size: 16px;
  font-weight: 500;
  z-index: 20000;
  max-width: 90%;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  letter-spacing: -0.01em;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease-out;
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style>